<mat-form-field class="w-100" appearance="outline">
  <ngx-spinner [zIndex]="-1" [name]="nombreSpinner" bdColor="rgba(255,255,255,0.8)" size="small"
              color=" var(--primary-color)" type="line-scale" [fullScreen]="false"></ngx-spinner>
  <mat-label>{{ label }}</mat-label>
  <input type="text" matInput [formControl]="control" [disabled]="!habilitado" [matAutocomplete]="auto">

  <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn.bind(this)">
    <mat-option *ngFor="let opcion of opcionesFiltradas | async" [value]="opcion">
      {{ opcion[mostrarPropiedad] }}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
